import React, { useState, useEffect } from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { formatDate } from "../../../Components/Common/FormatDate";
import { Link, useNavigate } from "react-router-dom";
import FranchiseEnquiryService from "../../../services/KangarooServices/FranchiseEnquiryService";
import UpdateStatus from "../component/UpdateStatus";

const FranchiseEnquiry = () => {
  const navigate = useNavigate();
  const [courseData, setCourseData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [isUpdateOpen, setIsUpdateOpen] = useState(false);
  const toggleUpdate = (item) => {
    setSelectedItem(item);
    setIsUpdateOpen(!isUpdateOpen);
  };
  const openModal = (id) => {
    setSelectedCourseId(id);
    setIsModalOpen(true);
  };

  const toggleModal = () => setIsModalOpen(!isModalOpen);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await FranchiseEnquiryService.getList();

        setCourseData(data);
      } catch (err) {
        console.error("ERROR:", err);
      }
    };

    fetchData();
  }, []);

  const handleDeleteClick = async (id) => {
    await FranchiseEnquiryService.delete(id);
    window.location.reload();
  };
  const statusColorMap = {
    New: "primary",
    InProgress: "warning",
    Closed: "success",
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Franchise Enquiry" pageTitle="User Management" />
        <Row>
          <Col>
            <div>
              <button
                className="btn btn-success"
                onClick={() => navigate("/franchise-enquiry/create")}
              >
                + Add
              </button>
            </div>
          </Col>
          <Col>
            <div className="d-md-flex justify-content-sm-end gap-2">
              <div className="search-box ms-md-2 flex-shrink-0 mb-3 mb-md-0">
                <Input
                  type="text"
                  className="form-control"
                  id="searchJob"
                  autoComplete="off"
                  placeholder="Search by name or course"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <i className="ri-search-line search-icon"></i>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          {courseData?.map((item, index) => {
            return (
              <Col className="mt-4" sm={6} xl={4} key={item.id || index}>
                <Card className="mb-3 border-0 shadow-sm h-100 d-flex flex-column hover-lift transition">
                  <CardHeader>
                    <Row>
                      <Col md={2}>
                        <div className="avatar-sm">
                          <div className="avatar-title rounded bg-success-subtle text-success fs-14 fw-semibold">
                            {item?.fullName
                              ?.split(" ")
                              .slice(0, 2) // take first and last name
                              .map((name) => name.charAt(0).toUpperCase())
                              .join("")}
                          </div>
                        </div>
                      </Col>

                      <Col md={10}>
                        <div className="d-flex justify-content-start align-content-center align-items-center ps-2 h-100">
                          <h5 className=" fw-semibold">{item?.fullName}</h5>
                        </div>
                      </Col>
                    </Row>
                  </CardHeader>

                  <CardBody className="flex-grow-1 d-flex flex-column">
                    <div className="">
                      <div className="mb-2 d-flex align-items-center">
                        <i className="bx bx-envelope text-primary me-2"></i>
                        <span className="small">{item?.email}</span>
                      </div>

                      <div className="mb-2 d-flex align-items-center">
                        <i className="bx bx-phone text-primary me-2"></i>
                        <span className="small">
                          {item?.phoneCountryCode} {item?.phone}
                        </span>
                      </div>

                      <div className="mb-2 d-flex align-items-center">
                        <i className="bx bx-map-pin text-success me-2"></i>
                        <span className="small">{item?.prefreredLocation}</span>
                      </div>
                      <div className=" d-flex align-items-center">
                        <i className="bx bx-time-five text-success me-2"></i>
                        <span className="small">
                          {formatDate(item?.createdAt)}
                        </span>
                      </div>
                    </div>
                    <hr className="text-muted" />

                    <div className="d-flex justify-content-between align-content-center align-items-center ">
                      <p className="d-flex align-items-center">
                        {item?.message?.length > 100
                          ? item.message.slice(0, 100) + "..."
                          : item?.message}
                      </p>
                    </div>
                  </CardBody>

                  <div className="card-footer bg-transparent  d-flex justify-content-between align-items-center ">
                    <Badge
                      color={statusColorMap[item?.status] || "secondary"}
                      className=" m-2 px-3 py-2 rounded-pill shadow-sm"
                    >
                      {item?.status}
                    </Badge>
                    <div className="d-flex justify-content-center align-items-center gap-1">
                      <Button
                        size="sm"
                        color="info"
                        className="btn-soft-info "
                        onClick={() =>
                          navigate(`/franchise-enquiry/${item.id}`)
                        }
                      >
                        <i className="ri-eye-line"></i>
                      </Button>
                      <Button
                        color="btn btn-soft-warning"
                        className="btn-sm"
                        size="sm"
                        onClick={() => toggleUpdate(item)}
                      >
                        <i className="ri-edit-line" />
                      </Button>
                      <Button
                        className="btn btn-soft-danger btn-sm"
                        color="danger"
                        size="sm"
                        onClick={() => handleDeleteClick(item.id)}
                      >
                        <i className="ri-delete-bin-5-line" />
                      </Button>
                    </div>
                  </div>
                </Card>
              </Col>
            );
          })}
        </Row>

        <UpdateStatus
          isOpen={isUpdateOpen}
          toggle={toggleUpdate}
          selectedItem={selectedItem}
        />
      </Container>
    </div>
  );
};

export default FranchiseEnquiry;
